var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enhanced-pdf-viewer"},[_c('div',{staticClass:"pdf-container",on:{"touchstart":_vm.handleTouchStart,"touchmove":_vm.handleTouchMove,"touchend":_vm.handleTouchEnd}},[_c('section',{staticClass:"main-section"},[_c('div',{ref:"pdfContent",attrs:{"id":"pdfContent"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }